// extracted by mini-css-extract-plugin
export default {"button":"AppPage-styles-module--button--ONVo0","avatar":"AppPage-styles-module--avatar--Mg06p","arrow":"AppPage-styles-module--arrow--cuRGs"};